import React from "react";
import { Link } from 'react-router-dom'

import Container from '../../components/Container'
import Hero from '../../components/Hero'
import Header from '../../components/Header/brandbook'
import Section from '../../components/Section'
import Icon from '../../components/Icon'
import IconDemo from '../../components/IconDemo'
import Grid from '../../components/Grid'
import Downloadable from '../../components/Downloadable'


export const path = '/brandbook/imagery'

export default function BrandbookPage() {
  return (
    <div className="light">
      <Header />
      <Hero>
        <Container size="large">

          <Grid grid="1-2">
            <></>
            <>
              <h1><span className="highlight">Tools and Rules</span> <br />Imagery</h1>
            </>
          </Grid>
        </Container>

      </Hero>
      <Container size="large">
      <Section>
          <Grid grid="1-2">
            <></>
            <>
              <h2>Products in use at venue/location</h2>
              <p>
                Idea: Point-of-view Waved product placement. Focusing on people having a good time. Short video clips as well? Ref. Foodsteps.
              </p>

              <h2>Customers portraits</h2>
              <p>
                Idea: Portraits of customers in context of their venue/location (with guests and visitors in the background?).
              </p>

              <h2>Founders, employees and team</h2>
              <p>
                Idea: Employees installing Waved on location, group stills in context of venue/location (with guests and visitors in the background?).
              </p>
            </>
          </Grid>
      </Section>


    <br />
    </Container>
    </div>
    )
  }
